import React, { FC, useEffect } from 'react';
import { Path, useLocation, useNavigate } from 'react-router-dom';
import { UserType } from 'utils/constants';
import { useAuth } from 'utils/contexts/auth-context';
import Page from '../../components/page/page.component';
import SelectLocation from './components/select-location.component';
interface IState {
  from?: Path;
}

const RequestLocation: FC = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const { location, loading, sorensonUser } = useAuth();

  const from: string = (state as IState)?.from?.pathname || '/';

  useEffect(() => {
    if (!loading && (location || sorensonUser.userType !== UserType.VRI))
      navigate(from, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  return (
    <Page pageTitle='Login Selector'>
      <SelectLocation />
    </Page>
  );
};

export default RequestLocation;
